import React, { useContext, useEffect, useState } from 'react';
import ErrorModal from '../common/UI/ErrorModal';
import {
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableContainer,
  Grid,
  Button,
  TableBody,
  Typography,
  Card,
  CardContent,
  Button as ReactButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { AuthContext } from '../common/context/auth-context';
import LoadingSpinner from '../common/UI/LoadingSpinner';
import { useHttpClient } from '../common/hooks/http-hook';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddTox from './components/toxes/add-tox';
import TextField from '@material-ui/core/TextField';
import { ChatList } from 'react-chat-elements';
import { useGetFilters } from '../common/hooks/getfilters-hook';
import Filter from '../common/UI/Filter';
import 'react-chat-elements/dist/main.css';
import 'react-vis/dist/style.css';
import LoopIcon from '@material-ui/icons/Loop';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ConfirmationDialog from '../common/UI/ConfirmationDialog';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import favIco from '../../public/images/logo_size.jpg';
import moment from 'moment-timezone';
import ARSFilter from '../common/UI/ARSFilter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(6)
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  add: {
    alignContent: 'right'
  }
}));

const VendorAlerts = (props) => {
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [toxes, setToxes] = useState([]);
  const [editTox, setEditTox] = useState(null); //for payer edit button
  const [rerender, setReRender] = useState(false);
  const {
    adminUsers,
    getAdminUsers,
    setSelectedButton,
    selectedButton,
    setFilterText,
    filterText,
    handleSetArsUser,
    arsUser,
    filterByARS
  } = useGetFilters(sendRequest, auth, showModal, false, null, rerender, null, setReRender);
  const [messageCount, setMessageCount] = useState(1); //how many previous messages to pull
  const [selectedUser, setSelectedUser] = useState();
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [voidImageID, setVoidImageID] = useState();

  useEffect(() => {
    if (props.selectedUser && adminUsers) {
      setSelectedButton(2); //set to all users
      const user = adminUsers.find((users) => users._id === props.selectedUser);
      if (user) {
        const myUser = {
          alt: user.firstName + ' ' + user.lastName,
          title: user.firstName + ' ' + user.lastName,
          subtitle: user.phoneNumber || 'No Number Entered',
          id: user._id,
          unread: '0',
          timeZone: user.timeZone || 'AMERICA/NEW_YORK'
        };
        setSelectedUser(myUser);
      }
    }
  }, [adminUsers]);

  useEffect(() => {
    //get users for tenant
    const getToxes = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + '/api/accountable/getvendoralerts',
          'POST',
          JSON.stringify({
            user: selectedUser || null,
            count: messageCount
          }),
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth.token
          }
        );
        if (responseData && !responseData.message && (!selectedUser || selectedUser.id === ''))
          setToxes(responseData.sort((a, b) => (a.toxDate < b.toxDate ? 1 : -1)));
        else if (responseData && !responseData.message && selectedUser && selectedUser.id !== '')
          setToxes(responseData.sort((a, b) => (a.toxDate < b.toxDate ? 1 : -1)));
      } catch (err) {}
    };
    getToxes();
  }, [sendRequest, showModal, selectedUser, messageCount]);

  useEffect(() => {
    //filter out non breathalyzer clients

    setFilteredUsers(adminUsers.filter((adminUser) => adminUser.recoveryTrekID));
  }, [adminUsers]);
  const addTox = (event) => {
    event.preventDefault();
    setEditTox(null);
    setShowModal(true);
  };

  const showEditModal = (event) => {
    setEditTox(event.currentTarget.value);
    setShowModal(true);
  };

  const handleChange = (event) => {
    let target = event.target.value;
    setFilterText(target);
    if (target.length > 2) getAdminUsers(target);
    else if (target.length < (filterText && filterText.length)) getAdminUsers(target);
  };

  const getMoreResults = (event) => {
    setMessageCount(messageCount + 1);
  };
  const saveSelectedUser = (event) => {
    setSelectedUser(event);
    setMessageCount(1);
  };

  const createPDF = async (event) => {
    if (!toxes) alert('Please select a user with data to export');
    else {
      let documentData = null;
      let data = [];
      data.push({
        text: 'You Are Accountable Breathalyzer Results',
        style: 'header',
        alignment: 'center'
      });
      data.push({
        text: 'https://youareaccountable.com',
        style: 'subheader',
        alignment: 'center'
      });
      data.push({
        text: '646-450-7641',
        style: 'subheader',
        alignment: 'center'
      });
      data.push({
        image:
          'data:image/png;base64,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',
        alignment: 'center'
      });
      let table = {
        style: 'tableExample',
        table: { body: [['Member Name', 'Date', 'Result', 'Notes']] }
      };
      toxes.map(async (tox) => {
        table.table.body.push([
          selectedUser ? selectedUser.title : auth.tenant,
          new Date(tox.toxDate).toLocaleString(),
          tox.toxResult,
          tox.Notes
        ]);
      });
      data.push(table);
      documentData = {
        content: data,
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        }
      };

      pdfMake.createPdf(documentData).download('YouAreAccountableBreathalyzerExport.pdf');
    }
  };

  const handleExclude = async () => {
    try {
      const responseData = await sendRequest(
        process.env.REACT_APP_BACKEND_URL + '/api/accountable/excludeimage',
        'POST',
        JSON.stringify({
          id: voidImageID
        }),
        {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth.token
        }
      );
      if (responseData) {
        setVoidImageID(null);
      }
    } catch (err) {
      setShowConfirmationDialog(false);
    }
    setShowConfirmationDialog(false);
  };

  return (
    <div className={classes.root}>
      {auth.accountableAdmin && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          close={() => {
            setShowConfirmationDialog(false);
            setVoidImageID(null);
          }}
          runConfirmation={handleExclude}
          title="Exclude Image From Facial Recognition"
          buttonTitle="Exclude Image"
        />
      )}
      {error && (
        <ErrorModal
          open={!!error}
          title="Error Creating Tox"
          alert={error}
          clearError={clearError}
        />
      )}
      {isLoading && <LoadingSpinner open={isLoading} />}
      {(auth.accountableAdmin || auth.provider) && (
        <TextField
          className={classes.textField}
          label="Filter By Last Name"
          name="filter"
          onChange={handleChange}
          variant="outlined"
        />
      )}
      <Grid container spacing={4}>
        {auth.accountableAdmin && (
          <AddTox open={showModal} close={setShowModal} editVal={editTox} User={selectedUser} />
        )}
        {(auth.accountableAdmin || auth.provider) && !props.selectedUser && (
          <Grid item lg={3} sm={12} xl={3} xs={12}>
            <Card>
              <CardContent>
                {(auth.accountableAdmin || auth.provider) && (
                  <>
                    <Filter
                      selectedButton={selectedButton}
                      setSelectedButton={setSelectedButton}
                      authContext={auth}
                      sms
                    />
                    <Typography variant="h4" color="primary">
                      Members
                    </Typography>
                    {auth.accountableAdmin && (
                      <ARSFilter
                        auth={auth}
                        arsUser={arsUser}
                        handleSetArsUser={handleSetArsUser}
                        filterByARS={filterByARS}
                      />
                    )}
                  </>
                )}
                <ChatList
                  onClick={saveSelectedUser}
                  className="chat-list"
                  dataSource={filteredUsers.map((user) => {
                    return {
                      avatar: favIco,
                      alt: user.firstName + ' ' + user.lastName,
                      title: user.firstName + ' ' + user.lastName,
                      subtitle: user.phoneNumber || 'No Number Entered',
                      id: user._id,
                      unread: '0',
                      timeZone: user.timeZone || 'AMERICA/NEW_YORK'
                    };
                  })}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
        <Grid
          item
          lg={props.selectedUser ? 12 : 8}
          sm={12}
          xl={props.selectedUser ? 12 : 8}
          xs={12}>
          <Card>
            <CardContent>
              {(auth.accountableAdmin || auth.provider) && !selectedUser && (
                <Typography
                  gutterBottom
                  className={classes.title}
                  color="textSecondary"
                  variant="h3">
                  Please Select a User
                </Typography>
              )}
              {(selectedUser || (!auth.accountableAdmin && !auth.provider)) && (
                <Typography
                  gutterBottom
                  className={classes.title}
                  color="textSecondary"
                  variant="h3">
                  {selectedUser ? selectedUser.title : auth.tenant}'s Breathalyzer Results
                </Typography>
              )}
              <Typography variant="h6" gutterBottom>
                Continuous Breathalyzer Monitoring acts as a safety measure for you and your loved
                ones. It reduces your families/support systems worries about needing to monitor you
                and allows you to not feel overwhelmed in your own home. It allows you to work on
                communication and growing along your path of recovery together. Continuous
                Breathalyzer Monitoring also serve as a way to see your progress - you will be able
                to see how far you have come and it is a testament to all of the hard work that you
                have been doing.{' '}
              </Typography>
              <Grid container justify="flex-end">
                {auth.accountableAdmin && (
                  <Button color="secondary" onClick={addTox}>
                    Add Tox&nbsp;&nbsp;
                    <AddCircleIcon color="secondary" fontSize="small" />
                  </Button>
                )}
                <Button onClick={createPDF} variant="contained" color="secondary">
                  Download Export
                </Button>
              </Grid>

              {
                <Grid container justify="center">
                  <ReactButton color="primary" onClick={getMoreResults} variant="contained">
                    See Prior Results&nbsp;&nbsp;
                    <LoopIcon color="secondary" fontSize="small" />
                  </ReactButton>
                  <br />
                </Grid>
              }

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {(auth.accountableAdmin || auth.provider) && <TableCell>Last Name</TableCell>}
                      {(auth.accountableAdmin || auth.provider) && (
                        <TableCell>First Name</TableCell>
                      )}
                      <TableCell>Breathalyzer Date</TableCell>
                      <TableCell>Breathalyzer Result</TableCell>
                      <TableCell>Notes</TableCell>
                      <TableCell>Picture</TableCell>
                      <TableCell>Verified</TableCell>
                      <TableCell>Location</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(((auth.accountableAdmin || auth.provider) && selectedUser) ||
                      (!auth.accountableAdmin && !auth.provider)) &&
                      toxes &&
                      toxes.map((tox) => {
                        let toxValue = '';
                        switch (tox.toxType) {
                          case 1:
                            toxValue = 'Alcohol';
                            break;
                          case 2:
                            toxValue = '10 Panel';
                            break;
                          case 3:
                            toxValue = '12 Panel';
                            break;
                          case 4:
                            toxValue = '14 Panel';
                            break;
                          case 5:
                            toxValue = 'Lab Confirmation';
                            break;
                          case 6:
                            toxValue = 'Breathalyzer';
                            break;
                        }
                        let bacDate = moment(tox.toxDate);
                        if (selectedUser) {
                          bacDate = bacDate.tz(selectedUser.timeZone);
                        }
                        bacDate = bacDate.format('MM/DD/YYYY hh:mm A z');

                        console.log(tox.toxDate);
                        console.dir(selectedUser);

                        return (
                          <TableRow key={tox._id}>
                            {(auth.accountableAdmin || auth.provider) && (
                              <TableCell>{tox.User.lastName}</TableCell>
                            )}
                            {(auth.accountableAdmin || auth.provider) && (
                              <TableCell>{tox.User.firstName}</TableCell>
                            )}
                            <TableCell>{bacDate}</TableCell>
                            <TableCell>{tox.toxResult}</TableCell>
                            <TableCell>{tox.Notes}</TableCell>
                            <TableCell>
                              {tox.image && (
                                <Button
                                  onClick={() => {
                                    setShowConfirmationDialog(true);
                                    setVoidImageID(tox._id);
                                  }}>
                                  <img src={tox.image} width="100px" />
                                </Button>
                              )}
                            </TableCell>
                            <TableCell>
                              {tox.image &&
                                (tox.recog ? (
                                  <CheckCircleIcon className={classes.icon} htmlColor="#73CD81" />
                                ) : (
                                  <HighlightOffIcon className={classes.icon} htmlColor="#FF0000" />
                                ))}
                            </TableCell>
                            {tox.latitude && !tox.access && (
                              <TableCell>
                                {' '}
                                <a
                                  href={`https://maps.google.com?q=${tox.latitude},${tox.longitude}`}
                                  target="_blank">
                                  Location
                                </a>
                              </TableCell>
                            )}
                            {tox.access && <TableCell>NA</TableCell>}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default VendorAlerts;
